import React from 'react';

const inr = (n) => `₹${Math.round(n || 0).toLocaleString('en-IN')}`;
const initials = (name) => {
  const s = String(name == null ? '' : name).trim();
  if (!s) return 'G';
  return s.split(/\s+/).slice(0, 2).map((w) => w[0]).join('').toUpperCase();
};

const badgeClass = (status) => {
  if (status === 'completed') return 'bg-green-100 text-green-700';
  if (status === 'pending') return 'bg-yellow-100 text-yellow-800';
  if (status === 'failed') return 'bg-red-100 text-red-700';
  return 'bg-slate-100 text-slate-600';
};
const badgeText = (status) => (status === 'completed' ? 'Paid' : status ? status[0].toUpperCase() + status.slice(1) : '—');

// items: [{ id, name, eventName, amount, status, timeLabel }]
const RecentRegistrations = ({ items = [] }) => (
  <div>
    {items.length === 0 && <div className="py-6 text-center text-sm text-slate-400 font-jakarta">No registrations yet</div>}
    {items.map((it, i) => (
      <div key={it.id || i} className={`flex items-center gap-3 py-2 ${i < items.length - 1 ? 'border-b' : ''}`} style={{ borderColor: '#f6f8fb' }}>
        <div className="w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-bold shrink-0" style={{ background: '#e0e7ff', color: '#4338ca' }}>{initials(it.name)}</div>
        <div className="flex-1 min-w-0">
          <div className="text-xs font-semibold text-slate-800 truncate font-jakarta">{it.name}</div>
          <div className="text-[11px] text-slate-400 truncate font-jakarta">{it.eventName} · {it.timeLabel}</div>
        </div>
        <div className="text-right shrink-0">
          <div className="text-xs font-bold text-slate-900">{inr(it.amount)}</div>
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${badgeClass(it.status)}`}>{badgeText(it.status)}</span>
        </div>
      </div>
    ))}
  </div>
);

export default RecentRegistrations;
